// extracted by mini-css-extract-plugin
export default {"form":"AdministracionInfo_form__C7GEW"};